package com.eladfinish.bible.contest.navigation

import androidx.navigation.NavType
import androidx.savedstate.SavedState
import androidx.savedstate.read
import androidx.savedstate.write
import kotlinx.serialization.KSerializer
import kotlinx.serialization.json.Json
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

@OptIn(ExperimentalEncodingApi::class)
class NavTypeSerializer<T>(
    private val serializer: KSerializer<T>,
    private val json: Json = Json,
) : NavType<T>(isNullableAllowed = false) {

    override fun get(bundle: SavedState, key: String): T? {
        return bundle.read { getStringOrNull(key) }?.decodeFromString()
    }

    override fun parseValue(value: String): T {
        return value.decodeFromString()
    }

    override fun serializeAsValue(value: T): String {
        return value.encodeToString()
    }

    override fun put(bundle: SavedState, key: String, value: T) {
        bundle.write { putString(key, value.encodeToString()) }
    }

    private fun String.decodeFromString(): T =
        json.decodeFromString(serializer, Base64.UrlSafe.decode(this).decodeToString())

    private fun T.encodeToString(): String =
        Base64.UrlSafe.encode(json.encodeToString(serializer, this).encodeToByteArray())

    companion object {
        inline fun <reified T> create(serializer: KSerializer<T>): NavTypeSerializer<T> {
            return NavTypeSerializer(serializer)
        }
    }
}
